export default __webpack_public_path__ + "static/media/phone.48d8b122.svg";